import { useEffect, useState } from "react";

import styles from "../../../../styles/mensageria.module.scss";

import classNames from "classnames/bind";
import { Button } from "../../../components/Button";
import { Hairline } from "../../../components/Hairline";
import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";
import { ForEach, If } from "../../../components/control-statements";
import { Icon } from "../../../components/core/Icon";
const css = classNames.bind(styles);

const TEMPLATE_STATUS = {
  APPROVED: "Aprovado",
  REJECTED: "Reprovado",
  IN_APPEAL: "Em análise",
};

export const TemplateList = ({
  configuredPhone,
  templates,
  newTemplate,
  onConfigurePhone,
  onEditTemplate,
  onDeleteTemplate,
}) => {
  const [phone, setPhone] = useState({
    ddd: "",
    number: "",
  });

  useEffect(() => {
    if (phone.ddd && phone.number && onConfigurePhone) {
      onConfigurePhone(`${phone.ddd}${phone.number}`);
    }
  }, [phone]);

  useEffect(() => {
    if (configuredPhone.ddd && configuredPhone.number) {
      setPhone(configuredPhone);
    }
  }, [configuredPhone]);

  return (
    <div className={styles.scroll}>
      <Label>Insira o número de telefone</Label>
      <div className="d-flex align-center">
        <Input
          placeholder="00"
          mask="99"
          className="flex"
          value={phone.ddd}
          onChange={(e) => setPhone({ ...phone, ddd: e.target.value })}
          disabled={templates?.length > 0}
        />
        <Input
          placeholder="00000-0000"
          mask="99999-9999"
          className="w-100 ml-15"
          value={phone.number}
          onChange={(e) => setPhone({ ...phone, number: e.target.value })}
          disabled={templates?.length > 0}
        />
      </div>

      <Hairline className="mt-20 mb-20" />

      <Label>Templates</Label>

      <If cond={!templates?.length}>
        <div className={styles.addTemplate} onClick={newTemplate}>
          <div className={styles.icon}>
            <Icon name="plus" size="1x" />
          </div>
          <p className={styles.title}>Adicionar template</p>
        </div>
      </If>

      <If cond={templates?.length > 0}>
        <div className={styles.templates}>
          <ForEach
            items={templates}
            render={(template, tIdx) => (
              <div className={styles.template}>
                <div className="d-flex flex-column align-start">
                  <p className={styles.name}>{template.name}</p>
                  <div
                    className={css({
                      status: true,
                      approved: template.status === "APPROVED",
                      analysis: template.status === "IN_APPEAL",
                      reproved: template.status === "REJECTED",
                    })}
                  >
                    {TEMPLATE_STATUS[template.status]}
                  </div>
                </div>

                <div className="d-flex align-center">
                  <Button
                    design="default-icon-mini-3"
                    onClick={() => onEditTemplate && onEditTemplate(template)}
                  >
                    <i className="far fa-pen" />
                  </Button>
                  <Button
                    design="default-icon-mini-3"
                    className="ml-15"
                    onClick={() =>
                      onDeleteTemplate && onDeleteTemplate(template.id)
                    }
                  >
                    <i className="far fa-trash" />
                  </Button>
                </div>
              </div>
            )}
          />

          {/*
          <div className={styles.template}>
            <div className="d-flex flex-column align-start">
              <p className={styles.name}>Promoção de São João</p>
              <div
                className={css({
                  status: true,
                  analysis: true,
                })}
              >
                Em análise
              </div>
            </div>

            <div className="d-flex align-center">
              <Button design="default-icon-mini-3">
                <i className="far fa-pen" />
              </Button>
              <Button design="default-icon-mini-3" className="ml-15">
                <i className="far fa-trash" />
              </Button>
            </div>
          </div>

          <div className={styles.template}>
            <div className="d-flex flex-column align-start">
              <p className={styles.name}>Dia dos namorados</p>
              <div
                className={css({
                  status: true,
                  approved: true,
                })}
              >
                Aprovado
              </div>
            </div>

            <div className="d-flex align-center">
              <Button design="default-icon-mini-3">
                <i className="far fa-pen" />
              </Button>
              <Button design="default-icon-mini-3" className="ml-15">
                <i className="far fa-trash" />
              </Button>
            </div>
          </div>

          <div className={styles.template}>
            <div className="d-flex flex-column align-start">
              <p className={styles.name}>1 ano da loja</p>
              <div
                className={css({
                  status: true,
                  reproved: true,
                })}
              >
                Reprovado
              </div>
            </div>

            <div className="d-flex align-center">
              <Button design="default-icon-mini-3">
                <i className="far fa-pen" />
              </Button>
              <Button design="default-icon-mini-3" className="ml-15">
                <i className="far fa-trash" />
              </Button>
            </div>
          </div>
        */}
        </div>
      </If>

      <div className={styles.footer}>
        <div className="d-flex flex-column w-100">
          <Button
            text="Salvar"
            design="primary"
            className="w-100"
            disabled={!(phone.ddd.length === 2 && phone.number.length === 10)}
            onClick={() => {}}
          />

          <If cond={templates.length > 0}>
            <Button
              text="Adicionar template"
              className="w-100 mt-15"
              onClick={newTemplate}
            />
          </If>
        </div>
      </div>
    </div>
  );
};
